 
  document.addEventListener('DOMContentLoaded', function() {
     
    const links = document.querySelectorAll('.wrapper-imags-ft a');

 
    links.forEach(function(link) {
      link.setAttribute('target', '_blank');
    });
  });


// back and next icons floating menu button 


document.addEventListener('DOMContentLoaded', function() {
  // Create the back icon element
  let backLink = document.createElement('a');
  backLink.id = "back-floating-button";

  let backIcon = document.createElement('img');
  backIcon.src = "https://cdn.shopify.com/s/files/1/0795/9412/7652/files/white-previous-50-thick_3fdb7340-d667-4b9d-a2f1-5d98f859aa6c.png?v=1718039007";
  backIcon.alt = "Back";

  backLink.appendChild(backIcon);

  // Create the next icon element
  let nextLink = document.createElement('a');
  nextLink.id = "next-floating-button";

  let nextIcon = document.createElement('img');
  nextIcon.src = "https://cdn.shopify.com/s/files/1/0795/9412/7652/files/white-next-50-thick_9ae82d7d-0a4b-496e-92a5-6f28dceb0748.png?v=1718039007";
  nextIcon.alt = "Next";

  nextLink.appendChild(nextIcon);

  // Append the links to the body of the document
  document.body.appendChild(backLink);
  document.body.appendChild(nextLink);

  // Add CSS directly via JavaScript
  backLink.style.position = 'fixed';
  backLink.style.bottom = '22px'; // Moved down a bit
  backLink.style.left = '90px'; // Adjusted to move towards the center
  backLink.style.zIndex = '1000';
  backLink.style.cursor = 'pointer'; // Change the mouse cursor to pointer

  nextLink.style.position = 'fixed';
  nextLink.style.bottom = '22px'; // Moved down a bit
  nextLink.style.right = '90px'; // Adjusted to move towards the center
  nextLink.style.zIndex = '1000';
  nextLink.style.cursor = 'pointer'; // Change the mouse cursor to pointer

  backIcon.style.width = '38px'; // Reduced size
  backIcon.style.height = '38px'; // Reduced size

  nextIcon.style.width = '38px'; // Reduced size
  nextIcon.style.height = '38px'; // Reduced size

  // Event listeners for back and next icons
  document.getElementById("back-floating-button").addEventListener("click", (e) => {
    e.stopPropagation();
    if (window.history.length > 1) {
      window.history.back();
    } else {
      console.log("No history to go back to.");
    }
  });

  document.getElementById("next-floating-button").addEventListener("click", (e) => {
    e.stopPropagation();
    if (window.history.length > 1) {
      window.history.forward();
    } else {
      console.log("No history to go forward to.");
    }
  });
});

// Change Size to EU Size 

 
 /*
document.addEventListener('DOMContentLoaded', function() {
  // Find all label elements with the class product__label
  let labels = document.querySelectorAll('.product__label');

  // Loop through each label element
  labels.forEach(function(label) {
    // Check if the label contains the text "Size"
    if (label.innerHTML.includes('Size')) {
  
      label.innerHTML = label.innerHTML.replace('Size', 'EU SIZE');
    }
  });
}); */

/* adding the wishlist on the header ---*/

 
let accountIcon = document.querySelector("#my_header > div.header__inner > div.header__row.header__row-desktop.lower.three-segment > div.header__row-segment.header__row-segment-desktop.right > a.header__icon-touch.header__icon-touch--account");

let wishlistHTML = `<a href="javascript:void(0)" class="header__icon h-wishlist-icon wishlist-page-widget">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" overflow="unset" class="icon">
    <path d="M12.4869 22C12.2364 21.9968 11.9918 21.9232 11.7804 21.7875C8.18822 19.57 5.48518 17.3766 3.2783 14.8705C2.01853 13.5287 1.04215 11.942 0.408559 10.207C-0.730606 6.84675 0.5832 2.9211 3.46882 1.07256C4.78425 0.221399 6.35422 -0.134962 7.90363 0.0659208C9.45304 0.266804 10.8831 1.01212 11.9431 2.17126C12.1376 2.37977 12.3162 2.60031 12.4869 2.81685C12.7194 2.51694 12.97 2.2317 13.2371 1.96275C13.8816 1.32075 14.6473 0.816306 15.4888 0.479444C16.3303 0.142583 17.2302 -0.0198119 18.1351 0.00192686C19.0214 0.0266866 19.8936 0.23235 20.6992 0.606539C21.5048 0.980728 22.2271 1.51571 22.8227 2.17928C25.0693 4.63732 25.6012 7.62065 24.3072 10.8045C23.6255 12.404 22.6611 13.8647 21.4613 15.1151C19.3548 17.3836 16.9713 19.3724 14.3683 21.0336C14.019 21.2662 13.6578 21.4907 13.3006 21.7113L13.1934 21.7795C12.9825 21.9174 12.738 21.9937 12.4869 22Z" stroke="currentColor"></path>
  </svg>
  <span class="wishlist-h-count wishlist-total-count" data-total="0">0</span>
</a>`;

// Step 3: Insert the wishlist icon to the left of the account icon
accountIcon.insertAdjacentHTML('beforebegin', wishlistHTML);


/* -- announcebar to trigger popup ----*/












